import { toast } from "react-toastify";

import { axiosB24NoTokenInstance } from "../../axios.config";
import { OrderActionTypes } from "./order.types";

export const addOrder = (data, tag) => (dispatch) => {
  dispatch({ type: OrderActionTypes.ADD.ORDER_PENDING });

  axiosB24NoTokenInstance
    .post(`/store/order/bot/${process.env.REACT_APP_BOT_ID}/${tag}`, data)
    .then((result) => {
      dispatch({
        type: OrderActionTypes.ADD.ORDER_SUCCESS,
        payload: result.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: OrderActionTypes.ADD.ORDER_ERROR,
        payload: error.response.data,
      });

      toast.error(error.response.data.message);
    });
};

export const saveOrder = (data) => (dispatch) => {
  dispatch({
    type: OrderActionTypes.SAVE,
    payload: data,
  });
};

export const resetOrder = (data) => (dispatch) => {
  dispatch({ type: OrderActionTypes.RESET.ORDER_ADD });
};
